import { css, jsx } from "@emotion/core";
import { Modal } from "antd";
import React from "react";

import Heading from "@/src/shared/components/Heading";
import { space } from "@/styles";

const { m } = space;
const style = {
  text: css`
    line-height: 1.75;
    font-size: 1.6rem;
  `,
};
const CommitteeTerminology = (props) => {
  const { visible, handleModalClose } = props;

  return (
    <Modal
      title={
        <Heading type={3} weight="bolder" css={m.b0} theme="primaryGray">
          APCIA Group Terminology
        </Heading>
      }
      visible={visible}
      footer={null}
      onCancel={handleModalClose}
      maskStyle={{
        backgroundColor: "rgba(0,38,73,0.65)",
      }}
      width={'71%'}
    >
      <Heading type={3} weight="bolder" theme="gray" css={style.title}>
        Committees
      </Heading>
      <p css={style.text}>
        Perform high-level policy work on an as-needed basis. Member companies
        interested in participating in high-level policy deliberations are asked
        to appoint a senior business leader empowered to make policy
        determinations on behalf of the company. All other members from the
        company will be associate committee members.
      </p>
      <Heading type={3} weight="bolder" theme="gray" css={style.title}>
        Subcommittees
      </Heading>
      <p css={style.text}>
        Established for a specific business segment (i.e., non-standard auto) or
        public policy issues (i.e., cyber insurance) within the jurisdiction of
        the committee. Subcommittees provide input to the parent committee as
        well as technical guidance on existing policy for consensus policy
        decision-making.
      </p>
      <Heading type={3} weight="bolder" theme="gray" css={style.title}>
        Working Groups
      </Heading>
      <p css={style.text}>
        Periodically created by committees with a mandate to address specific,
        temporary issues, and will specify whether executives, senior business
        leaders, counsels, or compliance staff are desired. Working groups
        provide input to the parent committee, for consensus policy
        decision-making.
      </p>
      <Heading type={3} weight="bolder" theme="gray" css={style.title}>
        Advisory Lists
      </Heading>
      <p css={style.text}>
        Available for member company staff interested in important legislative
        and regulatory updates but would not normally participate in Committee
        or Subcommittee discussions. Member company staff on the list may be
        contacted via email to provide input on specific issues.
      </p>
    </Modal>
  );
};

export default CommitteeTerminology;